import { GET_USER_SUBSCRIPTIONS } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USER_SUBSCRIPTIONS: {
      const { subscriptions } = action.payload;
      return { ...state, subscriptions };
    }
    default:
      return state;
  }
};
